
import './App.css'; 

import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import {BrowserRouter, Route,Routes} from "react-router-dom"
import Home from "./Routes/Home"
import Conferences from './Routes/Conferences';
import Downloads from './Routes/Downloads';
import MOUs from './Routes/MOUs';
import Projects from './Routes/Projects';
// import Faculties from './Routes/Faculties';
// import Staff from './Routes/Staff';
import Gallery from './Routes/Gallery';

import Projectawarded from './Routes/Projectawarded';

// faculty of social science 

import Facultyofsocialscience from './Routes/Facultyofsocialscience'; 

import Economics from './Routes/Dep-of-Social-Sciences/Economics/Economics'
import Education from './Routes/Dep-of-Social-Sciences/Education/Education'
import English from './Routes/Dep-of-Social-Sciences/English/English'
import History from './Routes/Dep-of-Social-Sciences/History/History'

import Islamiat from './Routes/Dep-of-Social-Sciences/Islamiat/Islamiat'

import  Management_Sciences from './Routes/Dep-of-Social-Sciences/Management Sciences/Management_Sciences'
import Political_Science from './Routes/Dep-of-Social-Sciences/Political Science/Political_Science';
import Psychology from './Routes/Dep-of-Social-Sciences/Psychology/Psychology';
import Urdu from './Routes/Dep-of-Social-Sciences/Urdu/Urdu'
// Faculty of Science 
import FacultyofSciences from './Routes/FacultyofSciences';
import Biochemistry from './Routes/Faculty of Sciences/Biochemistry/Biochemistry'
import Bioinformatics from './Routes/Faculty of Sciences/Bioinformatics/Bioinformatics'
import Biotechnology from './Routes//Faculty of Sciences/Biotechnology/Biotechnology'
import Botany from './Routes/Faculty of Sciences/Botany/Botany'
import Chemistry from './Routes/Faculty of Sciences/Chemistry/Chemistry'
import Computer from './Routes/Faculty of Sciences/Computer Science/Computer';
import Mathematics from './Routes/Faculty of Sciences/Mathematics/Mathematics';
import Microbiology from './Routes/Faculty of Sciences/Microbiology/Microbiology';
import Statistics from './Routes/Faculty of Sciences/Statistics/Statistics';
import Zoology from './Routes/Faculty of Sciences/Zoology/Zoology';



function App(){
  return(
    <BrowserRouter> 
    <Routes>
      <Route path='/' element={<Home/>}/>
      <Route path='/MOUs' element={<MOUs/>}/>
      <Route path='/Gallery' element={<Gallery/>}/>
      <Route path='/Projects' element={<Projects/>}/>
      <Route path='/Conferences' element={<Conferences/>}/>
      <Route path='/Downloads' element={<Downloads/>}/>
      {/* <Route path='/Staff' element={<Staff/>}/> */}
      <Route path='/Projectawarded' element={<Projectawarded/>}/>


      {/* Faculty of Sciences */}


      <Route path='/FacultyofSciences' element={<FacultyofSciences/>}/>
      
   
      <Route path='/Economics' element={<Economics/>}/>
      <Route path='/Education' element={<Education/>}/>
      <Route path='/English' element={<English/>}/>
      <Route path='/History' element={<History/>}/>
      
      <Route path='/Islamiat' element={<Islamiat/>}/>
   
      <Route path='/Management_Sciences' element={< Management_Sciences/>}/>
      <Route path='/Political_Science' element={<Political_Science/>}/>
      <Route path='/Psychology' element={<Psychology/>}/>
      <Route path='/Urdu' element={<Urdu/>}/>
      
      {/* Faculty of social science */}

      <Route path='/Facultyofsocialscience' element={<Facultyofsocialscience/>}/>

      <Route path='/Biochemistry' element={<Biochemistry/>}/>
      <Route path='/Bioinformatics' element={<Bioinformatics/>}/>
      <Route path='/Biotechnology ' element={<Biotechnology />}/>
      <Route path='/Botany' element={<Botany/>}/>
      <Route path='/Chemistry' element={<Chemistry/>}/>
      <Route path='/Computer' element={<Computer/>}/>
      <Route path='/Mathematics' element={< Mathematics/>}/>
      <Route path='/Microbiology' element={<Microbiology/>}/>
      <Route path='/Statistics' element={<Statistics/>}/>
      <Route path='/Zoology' element={<Zoology/>}/>
     
    </Routes>
    </BrowserRouter>
    
  ) 
}
export default App;
